module.exports = __webpack_public_path__ + "static/features_img_two-8b0d25e974b1f1db31076c52fe0ea950.png";